<template>
  <!-- <v-layout>
      <h1>Fixed Cost #{{$route.params.id}}</h1>
  </v-layout>-->
  <v-layout pl-2 pt-2 pr-2 pb-2 justify-center row>
    <v-flex xs2>
      <SimpleCard>
        <PromotionsSearchBox @search="search" @clear="clear" :query="query"></PromotionsSearchBox>
      </SimpleCard>
    </v-flex>
    <v-flex xs10 pl-2>
      <SimpleCard>
        <v-layout row wrap align-content-center justify-center>
          <PromotionsList
            style="width: 100%;"
            :promotions="promotions"
            :paginationProp="pagination"
            :loading="loading"
          ></PromotionsList>
          <v-flex v-if="!loading" pt-2 xs9 class="text-xs-center pt-2">
            <v-pagination
              @input="changePage"
              v-model="pagination.page"
              :length="num_pages"
              :total-visible="10"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </SimpleCard>
    </v-flex>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import PromotionsList from "@/components/settings/promotions/PromotionsList.vue";
import PromotionsSearchBox from "@/components/settings/promotions/PromotionsSearchBox.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "promotions",
  components: {
    SimpleCard,
    PromotionsList,
    PromotionsSearchBox
  },
  data: function() {
    return {
      offset: 0,
      count: 20,
      query: {
        search: ""
      },
      loading: true,
      pagination: { page: 1 },
      num_pages: 0,
      promotions: []
    };
  },
  mounted: async function() {
    this.getPromotions();
  },
  methods: {
    search: function() {
      this.pagination.page = 1;
      this.getPromotions();
    },
    clear: function() {
      this.query = {
        search: ""
      };
    },
    changePage: function(page) {
      this.pagination.page = page;
      console.log(page);
      this.getPromotions();
    },
    getPromotions: async function() {
      this.loading = true;

      try {
        let url = `${
          this.$store.state.apiUrl
        }/settings/promotions/list?offset=${this.count *
          (this.pagination.page - 1)}&count=${this.count}
        &query=${this.query.search}`;

        let response = await axios.get(url, {
          params: {}
        });

        this.promotions = response.data.promotions;

        this.pagination.page = response.data.pages.page;
        this.num_pages = response.data.pages.num_pages;

        console.log(response.data.num_pages);

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get promotions " + error);
      }
    }
  }
};
</script>
